export const ApiMessageCode = {
  MessageCode: {
    customerNotExist: 'ERRVNUMS09',
    emailAlreadyExist: 'ERRVNUMS11',
    tokenExpired: 'ERRVNUMS12',
    emailAlreadyChanged: 'ERRVNUMS16',
    emailNotExist: 'ERRVNUMS19',
    rateLimitExceeded: 'ERRVNUMS22',
  },
};
